/*
 * Favourites (wishlist) stored per browser in localStorage as an array of
 * product handles. Buttons: [data-wishlist-toggle="<handle>"]. Header badge:
 * [data-wishlist-count]. Favourites page: [data-wishlist-grid].
 *
 * Signed-in customers also keep the list on their customer account (metafield
 * custom.favoritter, via the app proxy /apps/klub/favoritter), which the
 * GOSPELLOOM app uses too.
 */
(function () {
  var KEY = 'gospelloom-favoritter';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: list } }));
  }

  // --- Customer account sync ---------------------------------------------
  var CUSTOMER = document.documentElement.getAttribute('data-customer-id');
  var SYNCED_KEY = 'gospelloom-favoritter-kunde';
  var ENDPOINT = '/apps/klub/favoritter';

  function storage(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }

  function push(list) {
    if (!CUSTOMER) return;
    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(list)
    }).catch(function () {});
  }

  // The first sync after login merges this browser's hearts into the account;
  // after that the account is the source of truth (so removals made in the
  // app stick). Signing out forgets the account's list on this browser.
  function pull() {
    if (!CUSTOMER) {
      if (storage(SYNCED_KEY)) {
        storage(SYNCED_KEY, null);
        storage(KEY, null);
        document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: [] } }));
      }
      return;
    }
    fetch(ENDPOINT, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (remote) {
        if (!Array.isArray(remote)) return;
        var firstSync = storage(SYNCED_KEY) !== CUSTOMER;
        var list = remote;
        if (firstSync) {
          read().forEach(function (h) { if (list.indexOf(h) === -1) list.push(h); });
          push(list);
          storage(SYNCED_KEY, CUSTOMER);
        }
        storage(KEY, JSON.stringify(list));
        document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: list } }));
      })
      .catch(function () {});
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Fjern fra favoritter' : 'Tilføj til favoritter');
      btn.classList.toggle('text-crimson-drop', on);
      var icon = btn.querySelector('.material-symbols-outlined');
      if (icon) icon.style.fontVariationSettings = on ? "'FILL' 1" : "'FILL' 0";
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.classList.toggle('hidden', list.length === 0);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle);
    else list.splice(i, 1);
    write(list);
    push(list);
  });

  document.addEventListener('wishlist:updated', paint);
  // Another tab changed the list.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) paint();
  });

  function money(cents) {
    return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = read();
    if (list.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.classList.remove('hidden');
      return;
    }
    if (empty) empty.classList.add('hidden');
    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      // Drop products that no longer exist so the list self-heals.
      var alive = products.filter(Boolean);
      if (alive.length !== list.length) {
        try { localStorage.setItem(KEY, JSON.stringify(alive.map(function (p) { return p.handle; }))); } catch (e) {}
      }
      if (alive.length === 0 && empty) empty.classList.remove('hidden');
      grid.innerHTML = alive.map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=600' : '';
        var price = (p.price_varies ? 'Fra ' : '') + money(p.price_min);
        return (
          '<div class="group relative flex flex-col bg-surface-container-lowest p-space-xs shadow-sm hover:shadow-md transition-shadow">' +
            '<a href="' + p.url + '" class="relative aspect-[4/5] bg-surface-container overflow-hidden block">' +
              (img ? '<img class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="600" height="750">' : '') +
            '</a>' +
            '<button type="button" data-wishlist-toggle="' + escapeHtml(p.handle) + '" aria-pressed="true" class="absolute top-space-sm right-space-sm w-8 h-8 rounded-full bg-surface-canvas/90 text-crimson-drop flex items-center justify-center" aria-label="Fjern fra favoritter">' +
              '<span class="material-symbols-outlined" style="font-size:16px;font-variation-settings:\'FILL\' 1">favorite</span>' +
            '</button>' +
            '<div class="p-space-sm flex flex-col gap-space-2xs">' +
              '<a href="' + p.url + '" class="font-body-lg text-body-lg font-medium text-type-primary">' + escapeHtml(p.title) + '</a>' +
              '<span class="font-label-code text-label-code text-type-primary font-bold">' + price + '</span>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    });
  }

  document.addEventListener('wishlist:updated', renderGrid);
  document.addEventListener('DOMContentLoaded', function () {
    paint();
    renderGrid();
    pull();
  });
})();
